export default "__VITE_ASSET__DTNy2gC7__"